import { createAsyncAction, createStandardAction } from 'typesafe-actions'
import {
  ActionRes,
  MemberPointListReq,
  MemberPointListRes,
  AdjustMemberPointListReq,
  PointConfigDetailReq,
  PointConfigDetailRes,
  UpdatePointConfigReq,
  DeltePointConfigReq,
  MemberListReq,
  MemberListRes,
  MemberDetailReq,
  MemberDetailRes,
  UpdateMemberReq,
  MemberPoinInfoReq,
  MemberPoinInfoRes,
  EarnPointHistoryReq,
  EarnPointHistoryRes,
  BurnPointHistoryReq,
  BurnPointHistoryRes,
  AllMemberEarnPointHistoryReq,
  AllMemberEarnPointHistoryRes,
  AllBurnPointHistoryReq,
  AllBurnPointHistoryRes,
} from './types'

export const getMemberPointListAction = createAsyncAction(
  'MEMBER_POINT/GET_MEMBER_POINT_LIST_REQ',
  'MEMBER_POINT/GET_MEMBER_POINT_LIST_SUCCESS',
  'MEMBER_POINT/GET_MEMBER_POINT_LIST_FAILURE',
)<MemberPointListReq, MemberPointListRes, Error>()

export const adjustMemberPointAction = createAsyncAction(
  'MEMBER_POINT/ADJUST_MEMBER_POINT_REQ',
  'MEMBER_POINT/ADJUST_MEMBER_POINT_SUCCESS',
  'MEMBER_POINT/ADJUST_MEMBER_POINT_FAILURE',
)<AdjustMemberPointListReq, ActionRes, Error>()

export const getPointConfigDetailAction = createAsyncAction(
  'MEMBER_POINT/GET_POINTCONFIG_DETAIL_REQ',
  'MEMBER_POINT/GET_POINTCONFIG_SUCCESS',
  'MEMBER_POINT/GET_POINTCONFIG_FAILURE',
)<PointConfigDetailReq, PointConfigDetailRes, Error>()

export const updateConfigPointAction = createAsyncAction(
  'MEMBER_POINT/UPDATE_CONFIG_POINT_REQ',
  'MEMBER_POINT/UPDATE_CONFIG_POINT_SUCCESS',
  'MEMBER_POINT/UPDATE_CONFIG_POINT_FAILURE',
)<UpdatePointConfigReq, ActionRes, Error>()

export const deleteConfigPointAction = createAsyncAction(
  'MEMBER_POINT/DELETE_CONFIG_POINT_REQ',
  'MEMBER_POINT/DELETE_CONFIG_POINT_SUCCESS',
  'MEMBER_POINT/DELETE_CONFIG_POINT_FAILURE',
)<DeltePointConfigReq, ActionRes, Error>()

//Member page
export const getMemberListAction = createAsyncAction(
  'MEMBER_POINT/GET_MEMBER_LIST_REQ',
  'MEMBER_POINT/GET_MEMBER_LIST_SUCCESS',
  'MEMBER_POINT/GET_MEMBER_LIST_FAILURE',
)<MemberListReq, MemberListRes, Error>()

export const getMemberDetailAction = createAsyncAction(
  'MEMBER_POINT/GET_MEMBER_DETAIL_REQ',
  'MEMBER_POINT/GET_MEMBER_SUCCESS',
  'MEMBER_POINT/GET_MEMBER_FAILURE',
)<MemberDetailReq, MemberDetailRes, Error>()

export const updateMemberAction = createAsyncAction(
  'MEMBER_POINT/UPDATE_MEMBER_REQ',
  'MEMBER_POINT/UPDATE_MEMBER_SUCCESS',
  'MEMBER_POINT/UPDATE_MEMBER_FAILURE',
)<UpdateMemberReq, ActionRes, Error>()

export const getMemberPointInfoAction = createAsyncAction(
  'MEMBER_POINT/GET_MEMBER_POINTINFO_REQ',
  'MEMBER_POINT/GET_MEMBER_POINTINFO_SUCCESS',
  'MEMBER_POINT/GET_MEMBER_POINTINFO_FAILURE',
)<MemberPoinInfoReq, MemberPoinInfoRes, Error>()

export const getEarnPointHistoryAction = createAsyncAction(
  'MEMBER_POINT/GET_EARN_POINT_HISTORY_REQ',
  'MEMBER_POINT/GET_EARN_POINT_HISTORY_SUCCESS',
  'MEMBER_POINT/GET_EARN_POINT_HISTORY_FAILURE',
)<EarnPointHistoryReq, EarnPointHistoryRes, Error>()

export const getBurnPointHistoryAction = createAsyncAction(
  'MEMBER_POINT/GET_BURN_POINT_HISTORY_REQ',
  'MEMBER_POINT/GET_BURN_POINT_HISTORY_SUCCESS',
  'MEMBER_POINT/GET_BURN_POINT_HISTORY_FAILURE',
)<BurnPointHistoryReq, BurnPointHistoryRes, Error>()

export const getAllEarnPointHistoryAction = createAsyncAction(
  'MEMBER_POINT/GET_ALL_EARN_POINT_HISTORY_REQ',
  'MEMBER_POINT/GET_ALL_EARN_POINT_HISTORY_SUCCESS',
  'MEMBER_POINT/GET_ALL_EARN_POINT_HISTORY_FAILURE',
)<AllMemberEarnPointHistoryReq, AllMemberEarnPointHistoryRes, Error>()

export const getAllBurnPointHistoryAction = createAsyncAction(
  'MEMBER_POINT/GET_ALL_BURN_POINT_HISTORY_REQ',
  'MEMBER_POINT/GET_ALL_BURN_POINT_HISTORY_SUCCESS',
  'MEMBER_POINT/GET_ALL_BURN_POINT_HISTORY_FAILURE',
)<AllBurnPointHistoryReq, AllBurnPointHistoryRes, Error>()

export const clearEventAction = createStandardAction('MEMBER_POINT/CLEAR_EVENT')<void>()
